export default {
    SET_FILE(state, file) {
        state.file = file;
        state.validationResults = {};
    },

    START_UPLOAD(state) {
        state.uploadInProgress = true;
    },

    CANCEL_UPLOAD(state) {
        state.uploadInProgress = false;
    },

    START_IMPORT(state) {
        state.importInProgress = true;
    },

    CANCEL_IMPORT(state) {
        state.importInProgress = false;
    },

    FINISH_IMPORT(state) {
        state.importInProgress = false;
        state.file = null;
        state.validationResults = {};
    },

    SET_VALIDATION_RESULTS(state, validationResults) {
        state.validationResults = validationResults;
        state.uploadInProgress = false;
    },

    UPDATE_TARGET(state, target) {
        Object.assign(state.target, target);

        state.validationResults = {};
    }
};
